import React from 'react';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import UserMenuContent from '../../../MenuContent/UserMenuContent';
import PopoverMenu from '../../../PopoverMenu/PopoverMenu';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

const IconWrapper = styled.span`
  display: inline-flex;
  border: 1px solid #363738;
  border-radius: 50%;
  color: #00c752;
`;

const UserMenu = () => {
  const intl = useIntl();
  return (
    <PopoverMenu
      icon={
        <IconWrapper>
          <AccountCircleIcon aria-hidden="true" />
        </IconWrapper>
      }
      ariaLabel={intl.formatMessage({ id: 'app.menu.aria.userMenu' })}>
      <UserMenuContent />
    </PopoverMenu>
  );
};

UserMenu.propTypes = {};

export default UserMenu;
